import { get } from 'lodash-es';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectSelectedShipmentIds = (state) => get(state, 'selectedShipmentIds', emptyArray);

export const selectCount = (state) => get(selectSelectedShipmentIds(state), 'length');
